import styles from './comment-section.module.scss';
import React, { useContext, useReducer, useState } from 'react';
import { ArticleOwner } from '../../organisms/article-owner/article-owner';
import { TComment, TUser } from '../../../models/common';
import Comment from '../../organisms/comment/comment';
import CloseIcon from '@mui/icons-material/Close';
import {
  WDialog,
  WDialogContent,
  WDialogTitle,
  WIconButton,
  WStack,
  WTypography,
} from '../../wrappers/wrapper';
import { useNavigate } from 'react-router-dom';
import { UserContext } from 'contexts/userContext';

export function CommentSection({
  commentData,
  replyComments,
  onPost,
  onClickUser,
  onLike,
  onDelete,
}: {
  commentData: TComment;
  replyComments: TComment[];
  onPost: (message: string, comment: TComment) => void;
  onClickUser: (userId: string) => void;
  onLike: (comment: TComment) => void;
  onDelete: (comment: TComment) => void;
}) {
  const { user } = useContext(UserContext);
  const navigate = useNavigate();
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const [likeUsers, setLikeUsers] = useState<TUser[]>([]);
  const [isLikesModalVisible, setIsLikesModalVisible] = useState(false);
  const [visibleInputComment, setVisibleInputComment] = useState<TComment>();

  const handleClickLikeCount = (comment: TComment) => {
    setLikeUsers(comment.likes as TUser[]);
    setIsLikesModalVisible(true);
  };

  const handleClickUser = (id: string) => {
    setIsLikesModalVisible(false);
    onClickUser(id);
  };

  const onReplyClick = (comment: TComment) => {
    if (!user?._id) return navigate('/login');

    setVisibleInputComment(comment);

    forceUpdate();
  };

  const handleClickPost = (message: string, replyComment: TComment) => {
    onPost(message, replyComment);
    setVisibleInputComment(undefined);
  };

  return (
    <WStack className={styles.commentSection}>
      <Comment
        comment={commentData}
        mainComment={commentData}
        isReplyInputVisible={visibleInputComment?._id === commentData._id}
        onClickUser={handleClickUser}
        onClickLike={onLike}
        onDelete={() => onDelete(commentData)}
        onClickLikeCount={handleClickLikeCount}
        onPost={(message) => handleClickPost(message, commentData)}
        onReply={onReplyClick}
      />

      <WStack className={styles.reply}>
        {replyComments?.map((replyComment, index) => (
          <Comment
            key={index}
            comment={replyComment}
            mainComment={commentData}
            isReplyInputVisible={visibleInputComment?._id === replyComment._id}
            onClickUser={handleClickUser}
            onClickLike={onLike}
            onDelete={() => onDelete(replyComment)}
            onClickLikeCount={handleClickLikeCount}
            onPost={(message) => handleClickPost(message, replyComment)}
            onReply={onReplyClick}
          />
        ))}
      </WStack>
      <WDialog
        open={isLikesModalVisible}
        onClose={() => setIsLikesModalVisible(false)}
        scroll="paper"
        maxWidth="xs"
        fullWidth
      >
        <WDialogTitle>
          <WStack direction="row" justifyContent="space-between" alignItems="center">
            <WTypography className={styles['like-count']}>{likeUsers.length} Likes</WTypography>
            <WIconButton onClick={() => setIsLikesModalVisible(false)}>
              <CloseIcon />
            </WIconButton>
          </WStack>
        </WDialogTitle>
        <WDialogContent className={styles['dialog']}>
          <WStack spacing={1.2}>
            {likeUsers.map((user, index) => (
              <ArticleOwner user={user} onClick={() => handleClickUser(user._id!)} key={index} />
            ))}
          </WStack>
        </WDialogContent>
      </WDialog>
    </WStack>
  );
}
